/* global __CLIENT__ */

import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';

const A1Alert = () => (
    <div>
        <Toaster
            position="top-right"
            reverseOrder={false}
            toastOptions={{
                style: {
                    background: '#FFFFFF',
                    color: '#000000',
                },
            }}
        />
    </div>
);

// function handleClose() {
//     toast.remove();
// }

const showAlert = (message, options) => {
    if (!__CLIENT__) {
        // To avoid alerts being cached (by sucuri and/or a1 cache)
        return false;
    }

    if (!options || !options.duration || !options.type) {
        throw Error('options is required and must contain type and duration');
    }

    const buttons = [];

    if (options.buttons && options.buttons.length > 0) {
        // Check if each button has all necessary parameters
        options.buttons.forEach((button) => {
            if (!button.text || !button.callback) {
                throw Error('Missing argument for button. text and callback are required');
            }

            return buttons.push(button);
        });
    }

    return toast(
        (t) => (
            <div className="tw-flex tw-items-center tw-gap-2">
                <div className="tw-mr-2">
                    {options.type === 'success' ? <FontAwesomeIcon icon={faCheckCircle} width="16" /> : <FontAwesomeIcon icon={faTimesCircle} width="16" />}
                </div>
                <div className="tw-flex-grow">
                    {message}
                </div>
                <div>
                    |
                </div>
                <div className="tw-flex tw-items-center tw-gap-2">
                    <button type="button" className="hover:tw-underline" onClick={() => toast.dismiss(t.id)}>Fechar</button>
                </div>
            </div>
        ),
        { dismissible: true, className: `toast-notification ${options.type}`, duration: options.duration },
    );
};

export function showInfo(message, _options) {
    if (_options && typeof _options !== 'object') {
        // _options must be an object!
        throw Error('_options must be an object');
    }

    const defaultInfoOptions = { type: 'info', duration: 3000 };
    const options = { ...defaultInfoOptions, ..._options };

    return showAlert(message, options);
}

export function showSuccess(message, _options) {
    if (_options && typeof _options !== 'object') {
        // _options must be an object!
        throw Error('_options must be an object');
    }

    const defaultSuccessOptions = { type: 'success', duration: 3000 };
    const options = { ...defaultSuccessOptions, ..._options };

    return showAlert(message, options);
}

export function showError(message, _options) {
    if (_options && typeof _options !== 'object') {
        // _options must be an object!
        throw Error('_options must be an object');
    }

    const defaultErrorOptions = { type: 'error', duration: Infinity };
    const options = { ...defaultErrorOptions, ..._options };

    return showAlert(message, options);
}

// Dismiss a specific alert (if id is provided) or all alerts
export function dismissAlert(id) {
    if (id) {
        toast.dismiss(id);
    } else {
        toast.dismiss();
    }
}

export default A1Alert;
